<template>
    <div class="accordion-faq wow move-up">
        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-1 class="faq-title">Completa gestione dei dati anagrafici</b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Con Simple Service puoi gestire tutti i dati anagrafici dei tuoi clienti e dei loro impianti, storicizzare gli interventi eseguiti, archiviare foto e conservare documenti, tutti in un unico posto, a portata di click!
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>
        
        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-2 class="faq-title">Gestione attività interventi e manutenzioni</b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        E' il cuore del sistema, ti permette di avere sotto controllo la gestione delle attività, dalla segnalazione di un guasto all'intervento pianificato.
                        Il calendario è visualizzabile sia nella classica versione a colonne che in una avanzata e permette l'immediamo monitoraggio delle risorse disponibili e dei carichi di lavoro.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-3 class="faq-title">Web-App per i tecnici</b-button>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Simple service è un web-app, basta un comune browser per poterla usare e "gira" perfettamente su qualsiasi dispositivo.
                        La sezione di Simple Service dedicata al personale tecnico è stata appositamente sviluppata per dispositivi di piccole e medie dimensioni.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-4 class="faq-title">Applicazione multilivello</b-button>
            </b-card-header>
            <b-collapse id="accordion-4" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Simple Service è un'applicazione multilivello che gestisce fino a 4 livelli di utenze<br>
                        Amministratori, personale di back-office, tecnici e clienti finali.<br>
                        A ciascuno il proprio ruolo per lavorare al meglio in sinergia.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-5 class="faq-title">Integrazione con sistemi di contabilità e fatturazione</b-button>
            </b-card-header>
            <b-collapse id="accordion-5" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Integrando Simple Service con il vostro sistema di contabilità è possibile generare un ordine o una fattura direttamente dal ticket di intervento.
                        E' anche possibile monitorare i crediti o gestire solleciti verso i clienti.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'Accordion',
    };
</script>
